'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRoot = function getRoot(state) {
  return state.analytics;
};

var isNewUser = exports.isNewUser = function isNewUser(state) {
  return getRoot(state).get('isNewUser');
};
var isNewPortal = exports.isNewPortal = function isNewPortal(state) {
  return getRoot(state).get('isNewPortal');
};